import { useApi } from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'
import { ShopPaymentMethod } from '@framework/model-types/ShopPaymentMethods'

interface ShopPaymentMethodsReturnType {
  methods: ShopPaymentMethod[]
  isLoading: ReturnType<typeof useApi>['isLoading']
  isError: ReturnType<typeof useApi>['isError']
}

export const useGetShopPaymentMethods = (
  shopId: string,
): ShopPaymentMethodsReturnType => {
  const url: string = `${API_ENDPOINTS.GET_PAYMENT_OPTIONS(shopId)}`
  const { data, isError, isLoading } = useApi(url)
  return {
    methods: data?.data,
    isLoading,
    isError,
  }
}
